import { useEffect, useState } from "react";
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { RichTextEditor } from "@mantine/tiptap";
import { useParams, useNavigate } from "react-router-dom";
import { fetchStoryById, updateStory } from "../../utils/api";

import Underline from "@tiptap/extension-underline";
import Highlight from "@tiptap/extension-highlight";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import Superscript from "@tiptap/extension-superscript";
import Subscript from "@tiptap/extension-subscript";

const extensions = [
  StarterKit,
  Underline,
  Highlight,
  Link,
  Superscript,
  Subscript,
  TextAlign.configure({
    types: ["heading", "paragraph"],
  }),
];

const editorStyle = {
  minHeight: 280,
  maxHeight: 420,
  overflowY: "auto",
  padding: "12px",
};

export default function StoryEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);

  const editorEN = useEditor({ extensions, content: "" });
  const editorHE = useEditor({ extensions, content: "" });
  const editorYI = useEditor({ extensions, content: "" });

  useEffect(() => {
    if (!editorEN || !editorHE || !editorYI) return;

    fetchStoryById(id).then((story) => {
      editorEN.commands.setContent(story.content || "");
      editorHE.commands.setContent(story.content_he || "");
      editorYI.commands.setContent(story.content_yi || "");
      setLoaded(true);
    });
  }, [id, editorEN, editorHE, editorYI]);

  const handleUpdate = async () => {
    await updateStory(id, {
      content: editorEN.getHTML(),
      content_he: editorHE.getHTML(),
      content_yi: editorYI.getHTML(),
    });

    navigate(-1);
  };

  if (!loaded) return null;

  const EditorBlock = ({ title, editor, dir }) => (
    <div style={{ marginBottom: 24 }}>
       <h3
      className="text-sm font-semibold mb-2"
      dir={dir}
      style={{ textAlign: dir === "rtl" ? "right" : "left" }}
    >
      {title}
    </h3>

      <RichTextEditor editor={editor}>
        <RichTextEditor.Toolbar sticky>
          <RichTextEditor.ControlsGroup>
            <RichTextEditor.Bold />
            <RichTextEditor.Italic />
            <RichTextEditor.Underline />
            <RichTextEditor.Strikethrough />
            <RichTextEditor.ClearFormatting />
          </RichTextEditor.ControlsGroup>

          <RichTextEditor.ControlsGroup>
        <RichTextEditor.H1 />
            <RichTextEditor.H2 />
            <RichTextEditor.H3 />
            <RichTextEditor.H4 />
          </RichTextEditor.ControlsGroup>

          <RichTextEditor.ControlsGroup>
            <RichTextEditor.BulletList />
            <RichTextEditor.OrderedList />
            <RichTextEditor.Blockquote />
          </RichTextEditor.ControlsGroup>

          <RichTextEditor.ControlsGroup>
            <RichTextEditor.AlignLeft />
            <RichTextEditor.AlignCenter />
            <RichTextEditor.AlignRight />
          </RichTextEditor.ControlsGroup>
        </RichTextEditor.Toolbar>

        <RichTextEditor.Content style={editorStyle} dir={dir} />
      </RichTextEditor>
    </div>
  );

  return (
    <div className="users-page">
      <h1 className="page-title">Edit Story</h1>

      <div className="table-wrapper">
        <div style={{ padding: 16 }}>
          <EditorBlock title="English" editor={editorEN} dir="ltr" />
          <EditorBlock title="עברית" editor={editorHE} dir="rtl" />
          <EditorBlock title="יידיש" editor={editorYI} dir="rtl" />

          <div style={{ textAlign: "right", marginTop: 12 }}>
            <button className="action-btn activate" onClick={handleUpdate}>
              Update Story
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
